import assert from "utils/assert";
import axios from "../axios";
import RestfulService from "./RestfulService";

const fileinfoService = new RestfulService("/files");
export default fileinfoService;

/**
 * fileinfoIds {string[]?} If unset, all files (for this organization) are returned!
 * @returns {Promise<FileUsage[]>} [{fileinfoId: string, usageId: string, usageType: string}]
 */
export function apiListUsage(fileinfoIds) {	
	return axios.get(`/files/usage?fileinfoIds=${fileinfoIds}`).then(({ data }) => data);
}

/**
 * TODO merge with RestfulService.create
 * 
 * @param {object} params
 * @param {File} params.file
 * @param {string[]} params.tags
 * @param {string[]} params.folders
 * @returns 
 */
export function apiUpload({ data }) {
	// Note: the server will sanity check tags and folders
	return axios.post(`/files/upload`, data).then(({ data }) => data);
};
fileinfoService.create = apiUpload; // HACK + untested


/**
 * TODO merge with RestfulService.delete
 * @param {FileInfo} fileInfo 
 * @returns {Promise<FileInfo>}
 */
export function apiArchiveFileInfo(fileInfo) {
	assert(fileInfo.id, "fileInfo.id is required");	
	const config = {};
	return axios.post(`/files/archive/${fileInfo.id}`, config)
		.then(({ data }) => data);
}
fileinfoService.delete = id => apiArchiveFileInfo({ id }); // HACK

/**
 * 
 * @param {FileInfo} fileInfo 
 * @returns {Promise<FileInfo>}
 */
export function apiRestoreFromArchiveFileInfo(fileInfo) {
	assert(fileInfo.id, "fileInfo.id is required");	
	const config = {};
	return axios.post(`/files/restore/${fileInfo.id}`, config)
		.then(({ data }) => data);
}

/**
 * 
 * @param {FileInfo} fileInfo 
 * @returns {Promise<FileInfo>}
 */
export function apiAddToFolders(fileInfo, folder) {
	assert(fileInfo.id, "fileInfo.id is required");	
	assert(folder, "folder is required");
	if ( ! fileInfo.folders) fileInfo.folders = [];
	if ( fileInfo.folders.includes(folder)) return fileInfo;
	// optimistically update the fileInfo
	const oldFolders = fileInfo.folders;
	fileInfo.folders = [...fileInfo.folders, folder];
	return fileinfoService.update(fileInfo.id, fileInfo)
		.catch(e => {
			// if the update fails, roll back the optimistic update
			fileInfo.folders = oldFolders;
			throw e;
		});
}

/**
 * 
 * @param {FileInfo} fileInfo 
 * @returns {Promise<FileInfo>}
 */
export function apiRemoveFromFolders(fileInfo, folder) {
	assert(fileInfo.id, "fileInfo.id is required");	
	assert(folder, "folder is required");
	if ( ! fileInfo.folders) fileInfo.folders = [];
	if ( ! fileInfo.folders.includes(folder)) return fileInfo;
	// optimistically update the fileInfo
	const oldFolders = fileInfo.folders;
	fileInfo.folders = fileInfo.folders.filter(f => f !== folder);
	return fileinfoService.update(fileInfo.id, fileInfo)
		.catch(e => {
			// if the update fails, roll back the optimistic update
			fileInfo.folders = oldFolders;
			throw e;
		});
}
